import { NavLink, Outlet } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../hooks/useAuth';
import { supplierPortalApi } from '../api';
import { ThemeToggle, ToastContainer, Icon } from '@metrodev/core-web';
import { NotificationBell } from '../components/notifications/NotificationBell';
import { NotificationToastContainer } from '../components/notifications/NotificationToast';
import { UserAvatar } from '../components/profile/UserAvatar';

const PORTAL_TABS: { label: string; to: string; end?: boolean }[] = [
  { label: 'Órdenes de compra', to: '/proveedor', end: true },
  { label: 'Precios', to: '/proveedor/precios' },
  { label: 'Cambios de precio', to: '/proveedor/propuesta' },
  { label: 'Cuenta', to: '/proveedor/cuenta' },
];

/**
 * Shell propio del portal de proveedores — deliberadamente NO reutiliza `Layout` (sidebar interno): un usuario
 * Proveedor no debe ver nada del sistema interno, ni siquiera oculto.
 */
export default function SupplierPortalLayout() {
  const { user, logout } = useAuth();
  const { data: supplier } = useQuery({ queryKey: ['supplier-portal', 'me'], queryFn: () => supplierPortalApi.getSupplierInfo() });
  const fullName = user ? `${user.firstName} ${user.lastName}` : '';

  return (
    <div style={{ minHeight: '100vh', background: 'var(--color-app)' }}>
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 8,
          padding: '12px clamp(16px, 4vw, 32px)',
          background: 'var(--color-sidebar)',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ width: 28, height: 28, borderRadius: 8, background: '#f5a623', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontFamily: 'var(--font-display)' }}>M</span>
          <p style={{ margin: 0, fontSize: 13.5, fontWeight: 700, fontFamily: 'var(--font-display)', color: 'var(--color-sidebar-text)' }}>
            Mirasoles · Portal de proveedores
          </p>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <ThemeToggle />
          <NotificationBell />
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 10px 4px 4px', borderRadius: 999, background: 'var(--color-sidebar-footer)' }}>
            <UserAvatar size={30} />
            <span style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--color-sidebar-text)', whiteSpace: 'nowrap' }}>
              {supplier?.name ?? '…'} · {fullName}
            </span>
          </div>
          <button
            onClick={logout}
            title="Cerrar sesión"
            aria-label="Cerrar sesión"
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-sidebar-text-muted)', display: 'flex', padding: 6, borderRadius: 6 }}
          >
            <Icon name="logout" size={18} />
          </button>
        </div>
      </header>

      <nav aria-label="Secciones del portal" style={{ display: 'flex', gap: 4, overflowX: 'auto', padding: '8px clamp(16px, 4vw, 32px) 0', borderBottom: '1px solid var(--color-border)', background: 'var(--color-surface)' }}>
        {PORTAL_TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end={tab.end}
            style={({ isActive }) => ({
              padding: '8px 14px',
              fontSize: 13.5,
              fontWeight: 600,
              whiteSpace: 'nowrap',
              textDecoration: 'none',
              color: isActive ? 'var(--color-primary)' : 'var(--color-text-muted)',
              borderBottom: `2px solid ${isActive ? 'var(--color-primary)' : 'transparent'}`,
            })}
          >
            {tab.label}
          </NavLink>
        ))}
      </nav>

      <main style={{ maxWidth: 1100, margin: '0 auto' }}>
        <Outlet />
      </main>

      <ToastContainer />
      <NotificationToastContainer />
    </div>
  );
}
